// Shortlist: Division
// 

JLM.MD.MenuShortlistDivision = function( container, division_type, initial_talent ) {
	
	const INSTANCE = new JLM.MD.Module();
	
	
	// Variables: Private _______________________________________________________
	
	// References
	let area, title_tally, talent_list;
	
	
	
	// Variables: Public ________________________________________________________
	
	// Content
	INSTANCE.entries = [];
	
	// Status
	INSTANCE.tally = 0;
	INSTANCE.is_open = true;
	
	
	
	// Constructor ______________________________________________________________
	
	function init() {
		// References
		let title;
		
		// Create structure
		area = $('<div class="division" data-status="open" data-tally="0" />').appendTo( container );
		title = $('<h5><span>' + JLM.MT.generateDivisionName( division_type ) + ' (<span class="tally">0</span>)</span><svg><use xlink:href="#jl_icon_arrow_up"></use></svg></h5>').appendTo( area );
		title_tally = $('.tally', title);
		talent_list = $('<ul />').appendTo( area );
		
		// Events
		title.on('click', INSTANCE.toggle);
		
		// Populate
		if ( $.isArray( initial_talent )) {
			initial_talent.forEach(function( talent_id ) {
				JLM.database.getTalentInfo('all', talent_id, function( talent_info ) {
					if ( talent_info ) {
						INSTANCE.addTalent( talent_info );
					}
				});
			});
		}
	}
	
	
	
	// Methods: Private _________________________________________________________
	
	// Set a new tally value
	// 
	function updateTally() {
		let tally = INSTANCE.entries.length;
		area.attr('data-tally', tally);
		title_tally.text( tally );
		INSTANCE.tally = tally;
	}
	
	
	// Remove talent from internal list
	// 
	function removeFromEntries( talent_id ) {
		for( let i = 0; i < INSTANCE.entries.length; i++ ) {
			if ( INSTANCE.entries[i].id == talent_id ) {
				let entry = INSTANCE.entries.splice(i, 1);
				return entry[0];
			}
		}
		return null;
	}
	
	
	// When talent is removed by clicking the remove button
	// 
	function onTalentRemove( talent_id ) {
		// Remove reference
		removeFromEntries( talent_id );
		
		// Update tally
		updateTally();
		
		// Announce change
		INSTANCE.dispatchEvent('remove', [ talent_id, division_type ]);
	}
	
	
	
	// Methods: Public __________________________________________________________
	
	// Open / Close
	// 
	INSTANCE.open = function() {
		area.attr('data-status', 'open');
		INSTANCE.is_open = true;
	};
	INSTANCE.close = function() {
		area.attr('data-status', 'closed');
		INSTANCE.is_open = false;
	};
	INSTANCE.toggle = function() {
		if ( INSTANCE.is_open ) INSTANCE.close();
		else INSTANCE.open();
	};
	
	
	// Add talent entry to division
	// 
	INSTANCE.addTalent = function( talent_info ) {
		// Create entry
		const entry = new JLM.MD.MenuShortlistEntry( talent_list, talent_info, division_type );
		entry.on('remove', onTalentRemove);
		INSTANCE.entries.push( entry );
		
		// Update tally
		updateTally();
	}
	
	
	// Remove talent entry from division
	// 
	INSTANCE.removeTalent = function( talent_id ) {
		// Remove reference
		let entry = removeFromEntries( talent_id );
		if ( entry ) entry.remove();
		
		// Update tally
		updateTally();
	}
	
	
	// Empty division list
	// 
	INSTANCE.empty = function() {
		// Remove elements
		INSTANCE.entries.forEach(function( entry ) {
			entry.remove();
		});
		
		// Empty references
		INSTANCE.entries = [];
		
		// Update tally
		updateTally();
	};
	
	
	
	// Initial Setup ____________________________________________________________
	
	init();
	return INSTANCE;
	
};